$(document).ready(function() {
	
	// Payment Info
	$("#showpaymentinfo").fancybox({
		'afterClose':function() {
			/*$('.header-container').show();*/
		},
		openEffect  : 'none',
		closeEffect : 'none',
	});
	/*$('#showpaymentinfo').click(function() {
		$('.header-container').hide();
	});*/
});